import { render, staticRenderFns } from "./p-box.vue?vue&type=template&id=c405f442&scoped=true&"
import script from "./p-box.vue?vue&type=script&lang=js&"
export * from "./p-box.vue?vue&type=script&lang=js&"
import style0 from "./p-box.vue?vue&type=style&index=0&id=c405f442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405f442",
  null
  
)

export default component.exports